import React, { useEffect, useMemo } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";
import { fetchMachineMaster } from "services/machineMaster";

const MachineDropdown = ({
  errors,
  control,
  setValue,
  getValues,
  watch,
  rowData,
  required,
  defaultValue,
}) => {
  const selectedMachine = watch("machine_id");

  const {
    data: machineData,
    isLoading,
    error,
  } = useQuery(["machine-master-list"], () => fetchMachineMaster(), {
    keepPreviousData: false,
    staleTime: DROPDOWN_STALE_TIME,
  });

  const options = useMemo(
    () =>
      machineData?.data?.data?.map((item) => ({
        value: item.id,
        label: item.machine_name,
      })) || [],
    [machineData]
  );

  useEffect(() => {
    if (options.length > 0) {
      let machineIdToSet = null;

      if (rowData?.machine_obj?.id) {
        machineIdToSet = rowData.machine_obj.id;
      } else if (rowData?.machine_id) {
        machineIdToSet = rowData.machine_id;
      } else if (defaultValue) {
        machineIdToSet = defaultValue;
      }

      if (machineIdToSet && !selectedMachine) {
        const selectedOption = options.find(
          (option) => option.value === machineIdToSet
        );
        if (selectedOption) {
          setValue("machine_id", selectedOption.value);
        }
      }
    }
  }, [rowData, options, setValue, defaultValue, selectedMachine]);

  const selectedOption = options.find(
    (option) => option.value === selectedMachine
  );

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading machineData</div>;

  return (
    <Controller
      name="machine_id"
      control={control}
      rules={{
        required: required ? "Machine is required" : false,
        validate: (value) => {
          if (required && !value) return "Machine is required";
          return true;
        },
      }}
      render={({ field }) => (
        <Select
          {...field}
          options={options}
          isClearable
          value={selectedOption || null}
          placeholder="Select Machine"
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          onChange={(selectedOption) => {
            const value = selectedOption ? selectedOption.value : "";
            field.onChange(value);
            setValue("machine_id", value);
          }}
          className={`react-select-container ${
            errors.machine_id ? "is-invalid" : ""
          }`}
        />
      )}
    />
  );
};

export default MachineDropdown;
